import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import CoreContent from '../../../content';

export const Content = styled(CoreContent).attrs({
  asSpan: true,
})``;

const Li = ({
  className,
  title,
  content,
  toPage,
  link,
  chevronRight = false,
}) => {
  // this doesnt bubble down to Content:
  const to = toPage?.slug ?? link;
  return (
    <li className={className}>
      <Button
        link
        possibleSpan
        chevronRight={chevronRight}
        to={to}
      >
        <Content
          content={content || title}
        />
      </Button>
    </li>
  );
};

export default styled(Li)`
`;
